import { Spin, Tooltip } from 'antd'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import DownLoadIcon from 'components/icons/DownLoad'
import LeftArrow from 'components/icons/LeftArrow'
import {
  RoleNameDiv,
  RoleNameFlex,
  VerticalDivider,
} from 'modules/Drives/ViewDrive/Style/style'
import {
  CandidatesSpan,
  LeftSection,
  PaddedDiv,
  SectionName,
  SectionWrapper,
  StyledTab,
  TopEndFlex,
  TopHeader,
} from 'modules/Exp-Candidates/ViewDriveRole/Style/style'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { exportCandidate } from '../../actions'
import ApplicantExport from './ApplicatExport'
import ApplicationTable from './ApplicationTable'
import Metrics from './Header/Metrics'

const { TabPane } = StyledTab

const CustomTab = ({ tabName, count, tooltip }) => (
  <Tooltip title={tooltip}>
    <div>
      {tabName} <CandidatesSpan>{count} </CandidatesSpan>
    </div>
  </Tooltip>
)

const ApplicantTrackingSystem = ({
  singleRoleData,
  applicantCandidateList,
  getApplicantMetrics,
  applicantMetrics,
  getApplicantCandidateList,
  roleBasedDegreeList,
  atsBasedCollegeList,
  atsBasedLocationList,
  atsBasedDegreeList,
  getUniqueStudentInstitutesList,
  getDegreesBasedOnRoles,
  getDegreeBasedOnATS,
  getCollegeBasedOnATS,
  getLocationBasedOnATS,
  notifyReschedule,
}) => {
  const params = useParams()
  const dispatch = useDispatch()

  let pageLimit = 10

  let [searchParams, setSearchParams] = useSearchParams()
  const [checkedIds, setCheckedIds] = useState([])
  const stage = searchParams.get('stage')
  const checkType = searchParams.get('type')

  const [exportModalVisible, setExportModalVisible] = useState(false)
  const [lastRound, setLastRound] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingExcel, setLoadingExcel] = useState(false)
  const [flag, setFlag] = useState(false)
  const [exportCard, setExportCard] = useState([])
  const [selectedFileType, setSelectedFileType] = useState('xlsx')
  const [searchValue, setSearchValue] = useState('')
  const [currentTab, setCurrentTab] = useState('')
  const [status, setStatus] = useState('')
  const [filterStatus, setFilterStatus] = useState('')
  const [selectedRound, setSelectedRound] = useState(stage || 'applications')
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')
  const [pageNum, setPageNum] = useState(0)
  const [count, setCount] = useState(1)

  const targetRoundName = 'offer'
  const [lastBeforeRound, setLastBeforeRound] = useState(null)

  useEffect(() => {
    const index = applicantMetrics?.round?.findIndex(
      item => item?.roundName === targetRoundName
    )
    if (index > 0) {
      setLastBeforeRound(applicantMetrics?.round[index - 1]?.roundName)
    }
  }, [applicantMetrics])

  const [candidateFilterData, setCandidateFilterData] = useState({
    rating: '',
    location: '',
    status: '',
    degreeDepartment: '',
    collegeName: '',
    gender: '',
    degreekeys: '',
  })

  const tabList = [
    {
      tabName: 'All Candidates',
      count: applicantCandidateList?.totalCount || 0,
      key: 'ACTIVE',
      tooltip: 'Shortlisted from previous round',
    },
    {
      tabName: 'Scheduled',
      count: applicantCandidateList?.scheduledCount || 0,
      key: 'SCHEDULED',
    },
    ...(checkType === 'FACE_TO_FACE' || checkType === 'GROUP'
      ? [
          {
            tabName: 'Status to be updated',
            count: applicantCandidateList?.tobeUpdated,
            key: 'TO_BE_UPDATED',
          },
        ]
      : []),
    {
      tabName: 'Shortlisted',
      count: applicantCandidateList?.qualifiedCount || 0,
      key: 'QUALIFIED',
    },
    {
      tabName: 'Rejected',
      count: applicantCandidateList?.rejectedCount || 0,
      key: 'REJECTED',
    },
    {
      tabName: 'Hold to compare',
      count: applicantCandidateList?.onHoldCount || 0,
      key: 'HELD_TO_COMPARE',
    },
    ...(checkType === 'FACE_TO_FACE' || checkType === 'GROUP'
      ? [
          {
            tabName: 'Reschedule',
            count: applicantCandidateList?.rescheduleCount,
            key: 'RESCHEDULE',
          },
        ]
      : []),
    {
      tabName: 'Absent',
      count: applicantCandidateList?.absentCount || 0,
      key: 'ABSENT',
    },
  ]

  const tabDeatils =
    selectedRound === 'applications'
      ? [
          {
            tabName: 'Applied Candidates',
            count: applicantMetrics?.candidateCount || 0,
            key: 'ACTIVE',
          },
          {
            tabName: 'Qualified for the next round',
            count: applicantCandidateList?.appliedCandidate || 0,
            key: 'SELECTED',
          },
          {
            tabName: 'Rejected',
            count: applicantCandidateList?.rejectedCandidate || 0,
            key: 'REJECTED',
          },
        ]
      : selectedRound === 'offer'
      ? [
          {
            tabName: 'Offer Released',
            count: applicantCandidateList?.offerCount || 0,
            key: 'RELEASED',
          },
          {
            tabName: 'Offer Not Released',
            count: applicantCandidateList?.offerRejectByCorpCount || 0,
            key: 'NOT_RELEASED',
          },
          {
            tabName: 'Offer accepted',
            count: applicantCandidateList?.offerAccpetCount || 0,
            key: 'ACCEPTED',
          },
          {
            tabName: 'Offer rejected',
            count: applicantCandidateList?.offerRejectCount || 0,
            key: 'REJECTED',
          },
        ]
      : selectedRound === lastBeforeRound
      ? [
          {
            tabName: 'All Candidates',
            count: applicantCandidateList?.totalCount || 0,
            key: 'ACTIVE',
            tooltip: 'Shortlisted from previous round',
          },
          {
            tabName: 'Scheduled',
            count: applicantCandidateList?.scheduledCount || 0,
            key: 'SCHEDULED',
          },
          ...(checkType === 'FACE_TO_FACE' || checkType === 'GROUP'
            ? [
                {
                  tabName: 'Status to be updated',
                  count: applicantCandidateList?.tobeUpdated,
                  key: 'TO_BE_UPDATED',
                },
              ]
            : []),
          {
            tabName: 'Qualified for offer',
            count: applicantCandidateList?.qualifiedCount || 0,
            key: 'QUALIFIED',
          },
          {
            tabName: 'Rejected',
            count: applicantCandidateList?.rejectedCount || 0,
            key: 'REJECTED',
          },
          {
            tabName: 'Hold to compare',
            count: applicantCandidateList?.onHoldCount || 0,
            key: 'HELD_TO_COMPARE',
          },
          ...(checkType === 'FACE_TO_FACE' || checkType === 'GROUP'
            ? [
                {
                  tabName: 'Reschedule',
                  count: applicantCandidateList?.rescheduleCount,
                  key: 'RESCHEDULE',
                },
              ]
            : []),
          {
            tabName: 'Absent',
            count: applicantCandidateList?.absentCount || 0,
            key: 'ABSENT',
          },
        ]
      : tabList

  const paths = [
    {
      from: 'Role View',
      path: `/roles/${params?.jobId}/view-roleChart`,
    },
  ]

  const fetchCandidateData = async () => {
    let { data, statuses } = await getApplicantCandidateList({
      roleId: params?.jobId,
      setLoading,
      searchValue,
      sortby: sortBy,
      orderby: orderBy,
      filterData: candidateFilterData,
      pageLimit: pageLimit,
      pageNum: pageNum,
      statusCand:
        selectedRound === 'applications' && status === 'ACTIVE'
          ? ''
          : selectedRound === 'applications'
          ? status
          : '',
      stage: selectedRound === 'applications' ? '' : selectedRound,
      offerStatus: selectedRound === 'offer' ? status : '',
      driveStatus:
        selectedRound !== 'applications' &&
        selectedRound !== 'offer' &&
        status === 'ACTIVE'
          ? ''
          : selectedRound !== 'applications' && selectedRound !== 'offer'
          ? status
          : '',
      checkedIds: checkedIds,
    })

    if (statuses >= 400) {
      ErrorMessage(data?.message)
    }
  }

  useEffect(() => {
    let getData
    if (searchValue) {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    } else {
      fetchCandidateData()
    }
    return () => clearTimeout(getData)
  }, [sortBy, orderBy, pageNum, currentPage, count, currentTab, candidateFilterData])

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  useEffect(() => {
    setSelectedRound(selectedRound || '')
  }, [])

  useEffect(() => {
    getDegreeBasedOnATS({ jobId: params?.jobId })
    getDegreesBasedOnRoles({ jobId: params?.jobId })
    getCollegeBasedOnATS({ jobId: params?.jobId })
    getLocationBasedOnATS({ jobId: params?.jobId })
  }, [params?.jobId])

  useEffect(() => {
    if (selectedRound === 'offer') {
      setCurrentTab('RELEASED')
    } else if (selectedRound === 'applications') {
      setCurrentTab('ACTIVE')
    } else {
      setCurrentTab('ACTIVE')
    }
  }, [selectedRound])

  useEffect(() => {
    getApplicantMetrics({ roleId: params?.jobId })
  }, [params?.jobId, searchValue])

  const onTabChange = key => {
    setCandidateFilterData({
      rating: '',
      location: '',
      status: '',
      degreeDepartment: '',
      collegeName: '',
      gender: '',
      degreekeys: '',
    })
    setCheckedIds([])
    setCurrentPage(0)
    setPageNum(0)
    setStatus(key)
    setCurrentTab(key)
  }

  const onHanldleModal = key => {
    setExportModalVisible(true)
  }

  const onDownloadGoogle = async () => {
    setLoadingExcel(true)
    dispatch(
      exportCandidate(
        params?.jobId,
        selectedRound === '',
        selectedFileType,
        exportCard,
        'GOOGLE'
      )
    )
      .then(response => {
        if (response?.status >= 200 && response?.status <= 300) {
          window.open(response?.data?.data?.spreadsheetUrl)
          SuccessMessage('Candidate list downloaded successfully!')
          onHanldleCloseModal()
        } else {
          ErrorMessage(response?.response?.data?.message)
        }
      })
      .catch(error => {
        console.error('Error downloading:', error)
        ErrorMessage('An error occurred while downloading the candidate list.')
      })
      .finally(() => {
        setLoadingExcel(false)
      })
  }

  const onHanldleCloseModal = key => {
    setFlag(false)
    setExportModalVisible(false)
    setExportCard([])
    setSelectedFileType('xlsx')
  }

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [candidateFilterData, searchValue])

  const onPageChange = value => {
    setPageNum(value)
  }

  useEffect(() => {
    if (selectedRound === 'applications') {
      setStatus('')
    } else if (selectedRound === 'offer') {
      setStatus('RELEASED')
    } else {
      setStatus('')
    }
  }, [selectedRound])
  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'Roles',
    'Total Applications'
  )

  return (
    <SectionWrapper>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <Link to={`/roles/${params?.jobId}/view-roleChart`}>
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                fromArr={paths}
                on={'Applications'}
                path={`/roles/${params?.jobId}/view-roleChart`}
              />
              <RoleNameFlex alignCenter>
                <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
                <RoleStatus status={singleRoleData?.status} />
              </RoleNameFlex>
            </SectionName>
          </LeftSection>
          <TopEndFlex alignCenter gap="15px">
            {subEvents?.includes('EXPORT TO EXCEL') && (
              <Button.Secondary
                height={'38px'}
                icon={<DownLoadIcon fill={true} />}
                text="Export to Excel"
                onClick={onHanldleModal}
              />
            )}
            {subEvents?.includes('EXPORT TO GOOGLE SHEET') && (
              <>
                {' '}
                <VerticalDivider />
                <Button.Secondary
                  height={'38px'}
                  icon={loadingExcel ? <Spin /> : <DownLoadIcon fill={true} />}
                  text="Export to Google Sheet"
                  onClick={onDownloadGoogle}
                />
              </>
            )}
          </TopEndFlex>
        </TopHeader>
        <Metrics
          applicantMetrics={applicantMetrics}
          selectedRound={selectedRound}
          setSelectedRound={setSelectedRound}
          setSearchParams={setSearchParams}
          setCurrentPage={setPageNum}
          setCurrentTab={setCurrentTab}
          setStatus={setStatus}
          setFilterStatus={setFilterStatus}
          setLastRound={setLastRound}
          setCheckedIds={setCheckedIds}
          setCandidateFilterData={setCandidateFilterData}
        />
        <StyledTab
          onChange={onTabChange}
          width={'100%'}
          activeKey={currentTab}
          defaultActiveKey={currentTab}
        >
          {tabDeatils?.map(data => {
            return (
              <TabPane
                tab={
                  <CustomTab
                    tabName={data?.tabName}
                    count={getZeroBeforeInt(data?.count)}
                    tooltip={data?.tooltip}
                  />
                }
                key={data?.key}
              >
                <ApplicationTable
                  loading={loading}
                  setLoading={setLoading}
                  checkedIds={checkedIds}
                  setCheckedIds={setCheckedIds}
                  pageLimit={pageLimit}
                  pageNum={pageNum}
                  onPageChange={onPageChange}
                  setCandidateFilterData={setCandidateFilterData}
                  candidateFilterData={candidateFilterData}
                  handleSort={handleSort}
                  applicantCandidateList={applicantCandidateList}
                  getApplicantCandidateList={getApplicantCandidateList}
                  singleRoleData={singleRoleData}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  roleBasedDegreeList={roleBasedDegreeList}
                  atsBasedDegreeList={atsBasedDegreeList}
                  atsBasedCollegeList={atsBasedCollegeList}
                  atsBasedLocationList={atsBasedLocationList}
                  getUniqueStudentInstitutesList={
                    getUniqueStudentInstitutesList
                  }
                  getDegreesBasedOnRoles={getDegreesBasedOnRoles}
                  getDegreeBasedOnATS={getDegreeBasedOnATS}
                  getCollegeBasedOnATS={getCollegeBasedOnATS}
                  getLocationBasedOnATS={getLocationBasedOnATS}
                  setSearchParams={setSearchParams}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  currentTab={currentTab}
                  setStatus={setStatus}
                  filterStatus={filterStatus}
                  setFilterStatus={setFilterStatus}
                  status={status}
                  stage={stage}
                  applicantMetrics={applicantMetrics}
                  selectedRound={selectedRound}
                  notifyReschedule={notifyReschedule}
                  lastRound={lastRound}
                />
              </TabPane>
            )
          })}
        </StyledTab>
        {exportModalVisible && (
          <ApplicantExport
            setFlag={setFlag}
            flag={flag}
            exportModalVisible={exportModalVisible}
            onHanldleCloseModal={onHanldleCloseModal}
            setExportCard={setExportCard}
            exportCard={exportCard}
            selectedRound={selectedRound}
            setLoading={setLoading}
            loading={loading}
            setSelectedFileType={setSelectedFileType}
            selectedFileType={selectedFileType}
            setSelectedRound={setSelectedRound}
            lastRound={lastRound}
            singleRoleData={singleRoleData}
          />
        )}
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default ApplicantTrackingSystem
